var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_44",
    "data-name": "Layer 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.19 2.5a7.73 7.73 0 1 0 7.73 7.73 7.74 7.74 0 0 0 -7.73-7.73zm0 12.46a4.73 4.73 0 1 1 4.73-4.73 4.73 4.73 0 0 1 -4.73 4.77z",
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.19 24.27a7.73 7.73 0 1 0 7.73 7.73 7.74 7.74 0 0 0 -7.73-7.73zm0 12.46a4.73 4.73 0 1 1 4.73-4.73 4.73 4.73 0 0 1 -4.73 4.73z",
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.19 46a7.73 7.73 0 1 0 7.73 7.73 7.74 7.74 0 0 0 -7.73-7.73zm0 12.46a4.73 4.73 0 1 1 4.73-4.73 4.73 4.73 0 0 1 -4.73 4.77z",
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.92 14.84h27a4.62 4.62 0 1 0 0-9.23h-27a4.62 4.62 0 0 0 0 9.23zm0-6.23h27a1.62 1.62 0 1 1 0 3.23h-27a1.62 1.62 0 0 1 0-3.23z",
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.92 27.38h-27a4.62 4.62 0 0 0 0 9.24h27a4.62 4.62 0 0 0 0-9.24zm0 6.24h-27a1.62 1.62 0 0 1 0-3.24h27a1.62 1.62 0 0 1 0 3.24z",
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.92 49.15h-27a4.62 4.62 0 0 0 0 9.23h27a4.62 4.62 0 1 0 0-9.23zm0 6.23h-27a1.62 1.62 0 0 1 0-3.23h27a1.62 1.62 0 1 1 0 3.23z",
    fill: "currentColor",
    "data-original": "#000000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.8d9a605c84f12c80134dbc6ddc293db0.svg";
export { ForwardRef as ReactComponent };